export function bytes(value: number): string {
  if (!value) return '0 Б';
  const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];
  const i = Math.min(Math.floor(Math.log(value) / Math.log(1024)), units.length - 1);
  return `${(value / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function bps(value: number): string {
  if (!value) return '0';
  if (value >= 1e9) return `${(value / 1e9).toFixed(2)} Гбит/с`;
  if (value >= 1e6) return `${(value / 1e6).toFixed(1)} Мбит/с`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(0)} кбит/с`;
  return `${value} бит/с`;
}

export function duration(seconds: number | null): string {
  if (seconds === null) return '—';
  if (seconds < 60) return `${seconds} с`;
  const m = Math.floor(seconds / 60);
  if (m < 60) return `${m} мин`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ч ${m % 60} мин`;
  return `${Math.floor(h / 24)} д ${h % 24} ч`;
}

export function dateTime(ms: number | null): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'medium' });
}

export function time(ms: number | null): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
